import SharedContentModel from 'models/SharedContentModel';

export default Backbone.Collection.extend({
    model: SharedContentModel
}, {
    type: 'sharedContent'
});
